import React from "react";

const Parallax2 = (props) => {
  return (
    <div className="parallax  h-80  bg-[url('https://images.unsplash.com/photo-1501349800519-48093d60bde0?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTF8fHNjaG9vbHxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60')] bg-fixed bg-cover bg-top bg-no-repeat">
      <div className="absolute flex h-80 w-full flex-col items-center justify-around bg-black opacity-70">
        <div className="w-11/12">
          <div className="text-5xl font-bold text-sky-400">{props.heading}</div>
          <h1 className="mt-4 text-xl font-bold text-white">
            {props.subHeading}
          </h1>
        </div>
      </div>
    </div>
  );
};

export default Parallax2;
